import React from 'react';
import LoadingIndicator from '../LoadingIndicator';
import styles from './styles.scss';

const propTypes = {};

const defaultProps = {};

const FacilitiesLegendItemLoading = () => (
  <li className={styles.loadingIndicator}>
    <LoadingIndicator />
  </li>
);

FacilitiesLegendItemLoading.propTypes = propTypes;
FacilitiesLegendItemLoading.defaultProps = defaultProps;

export default FacilitiesLegendItemLoading;
